export const ADMIN_BASE_PATH = '/cp-login'

export const ADMIN_LOGIN_PATH = ADMIN_BASE_PATH
export const ADMIN_DASHBOARD_PATH = `${ADMIN_BASE_PATH}/dashboard`

export function adminPath(segment = '') {
  if (!segment || segment === '/') return ADMIN_BASE_PATH
  return `${ADMIN_BASE_PATH}/${String(segment).replace(/^\//, '')}`
}

export function isAdminPath(pathname = '') {
  return pathname === ADMIN_BASE_PATH || pathname.startsWith(`${ADMIN_BASE_PATH}/`)
}
